import { render, staticRenderFns } from "./SHeaderNotice.vue?vue&type=template&id=76bcb248&scoped=true"
import script from "./SHeaderNotice.vue?vue&type=script&lang=js"
export * from "./SHeaderNotice.vue?vue&type=script&lang=js"
import style0 from "./SHeaderNotice.vue?vue&type=style&index=0&id=76bcb248&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bcb248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76bcb248')) {
      api.createRecord('76bcb248', component.options)
    } else {
      api.reload('76bcb248', component.options)
    }
    module.hot.accept("./SHeaderNotice.vue?vue&type=template&id=76bcb248&scoped=true", function () {
      api.rerender('76bcb248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/SHeaderNotice.vue"
export default component.exports